import React from "react";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
//import "leaflet-control-geocoder";
import MapGeocoder from "./MapGeocoder";
import Droppoints from "../Droppoints";
import useGeoLocation from "./useGeoLocation";

function LeafletMap(props) {
  const location = useGeoLocation();
  const titleLayer = "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=" + process.env.REACT_APP_MAPBOX_TOKEN

  return (
    <>
      <div id="map">
        {location.loaded && !location.error && (
          <MapContainer
            center={[location.coordinates.lat, location.coordinates.lng]}
            zoom={9}
            scrollWheelZoom={true}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url={titleLayer}
            />
            <Marker
              icon={DefaultIcon}
              position={[location.coordinates.lat, location.coordinates.lng]}
            ></Marker>
            <Droppoints />
            <MapGeocoder />
          </MapContainer>
        )}
      </div>
    </>
  );
}

let DefaultIcon = L.icon({
  iconUrl: "/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
});

export default LeafletMap;
